/* Onlinedukan: cart delivery details -> Shopify checkout (prefilled) */
(function () {
  var btn = document.getElementById('od-checkout-btn');
  if (!btn) return;

  var err = document.getElementById('od-cart-error');
  function val(id) {
    var el = document.getElementById(id);
    return el ? el.value.trim() : '';
  }
  function showError(msg) {
    if (!err) return;
    err.textContent = msg;
    err.hidden = false;
  }

  btn.addEventListener('click', function (e) {
    e.preventDefault();
    if (err) err.hidden = true;

    var fullName = val('od-fullname');
    var phone = val('od-phone');
    var address = val('od-address');
    var city = val('od-city');
    var postal = val('od-postal');

    if (!fullName || !phone || !address || !city || !postal) {
      showError('Please fill in Full Name, Phone Number, Complete Address, City and Postal Code.');
      var first = ['od-fullname', 'od-phone', 'od-address', 'od-city', 'od-postal'].filter(function (id) { return !val(id); })[0];
      if (first) document.getElementById(first).focus();
      return;
    }

    var digits = phone.replace(/[^0-9+]/g, '');
    if (digits.replace(/\D/g, '').length < 10) {
      showError('Please enter a valid phone number.');
      document.getElementById('od-phone').focus();
      return;
    }

    var parts = fullName.split(/\s+/);
    var firstName = parts.shift();
    var lastName = parts.join(' ') || '-';

    btn.disabled = true;
    btn.textContent = 'Please wait...';

    var attributes = {
      'Full Name': fullName,
      'Phone Number': phone,
      'Complete Address': address,
      'City': city,
      'Postal Code': postal
    };

    function go() {
      var q = [
        'checkout[shipping_address][first_name]=' + encodeURIComponent(firstName),
        'checkout[shipping_address][last_name]=' + encodeURIComponent(lastName),
        'checkout[shipping_address][address1]=' + encodeURIComponent(address),
        'checkout[shipping_address][city]=' + encodeURIComponent(city),
        'checkout[shipping_address][zip]=' + encodeURIComponent(postal),
        'checkout[shipping_address][phone]=' + encodeURIComponent(phone),
        'checkout[shipping_address][country]=Pakistan'
      ].join('&');
      window.location.href = '/checkout?' + q;
    }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).then(go).catch(go);
  });
})();
